import { useMatchData } from "../../../../mls-match-list/utils";
import React from "react";
import { StyledScorebugLive } from "../StyledScorebug";
import Goal from "./Goal/Goal";

export const ScorebugLive = ({
  homeScore,
  awayScore,
  homeShootoutScore,
  awayShootoutScore,
}) => {
  const { isRecentGoal, count } = useMatchData();

  const stages = {
    goal: "goal",
    goalScore: "goal-score",
    live: "live",
  };

  const stage = isRecentGoal
    ? count <= 5
      ? stages.goal
      : stages.goalScore
    : stages.live;

  const hasShootout = !!homeShootoutScore || !!awayShootoutScore;
  const homeDisplay = hasShootout
    ? `${homeScore}(${homeShootoutScore})`
    : `${homeScore}`;

  const awayDisplay = hasShootout
    ? `${awayScore}(${awayShootoutScore})`
    : `${awayScore}`;

  return (
    <StyledScorebugLive
      className={`mls-c-scorebug__live mls-c-scorebug__live--${stage}`}
    >
      <Goal
        homeDisplay={homeDisplay}
        awayDisplay={awayDisplay}
      />
    </StyledScorebugLive>
  );
};
